import React from 'react';
import { useNavigate } from 'react-router-dom';

const MainLogo = ({ typeSmaller, goHome }) => {
  const navigate = useNavigate();
  const handleLogoClick = () => {
    if (goHome) {
      navigate('/');
    }
  };

  return (
    <div className={`main-logo-group ${typeSmaller ? 'type-smaller' : ''}`} onClick={handleLogoClick}>
      <a className={'main-logo-link'}>
        <img
          fetchpriority='high'
          src={typeSmaller ? '/images/logo_popup_mubeat_live.png' : '/images/logo_mubeat_live.png'}
          alt='Mubeat Live Logo'
          className={'main-logo-img'}
        />
      </a>
    </div>
  );
};

export default MainLogo;
